var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgObjectMask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.647461,
    y: 0.615479,
    width: 57.4736,
    height: 57.4729,
    stroke: "#164F68"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1791 46.2039L29.1768 29.3494H29.5898L29.5922 46.2039H29.1791Z",
    fill: "#598599"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5316 29.575L12.5312 29.1619L29.3577 29.1473L29.3579 29.5602L12.5316 29.575Z",
    fill: "#598599"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4179 38.3921L20.3662 37.3427L28.8596 28.8285L29.9115 29.8779L21.4179 38.3921Z",
    fill: "#00405B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5374 29.4905L29.2451 29.1988L37.6876 20.7361L37.9797 21.0276L29.5374 29.4905Z",
    fill: "#598599"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2387 30.0977H28.6416L28.6432 12.5L30.1287 12.5002L30.1276 28.6117H46.2387V30.0977Z",
    fill: "#00405B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectMask);
export default __webpack_public_path__ + "static/media/object_mask.0254dd4421b833a531b16cf43c1641e2.svg";
export { ForwardRef as ReactComponent };